import * as React from 'react';
import { ChartComponentProps } from 'react-chartjs-2';
import { SharedChartRenderProps, getOptions } from './Shared';
import { observer } from 'mobx-react';

interface GenericChart {
    (props: ChartComponentProps): JSX.Element;
}

type ChartRenderProps = SharedChartRenderProps & { ChartTypeGenerator: GenericChart};

@observer
export class GenericChartRender extends React.Component<ChartRenderProps> {
    public render() {
        
        let RenderableChart = this.props.ChartTypeGenerator({
            ...this.props,
            options: getOptions(this.props.CurrentChart)
        } as ChartComponentProps);

        return  (
            <div className="widget-frame">
               {RenderableChart}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/container/Chart/renders/GenericChart.tsx